// Live-format a US phone number as the user types: (###) ###-####.
// Strips non-digits, caps at 10, and only adds punctuation for the digits
// present so backspacing feels natural.
export function formatPhone(value) {
  const d = String(value || '').replace(/\D/g, '').slice(0, 10);
  if (d.length === 0) return '';
  if (d.length < 4) return `(${d}`;
  if (d.length < 7) return `(${d.slice(0, 3)}) ${d.slice(3)}`;
  return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;
}
